import {SvgIcon} from "@material-ui/core";

export const CustomGlobeStandIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M8 10.4996C10.4853 10.4996 12.5 8.48492 12.5 5.99963C12.5 3.51435 10.4853 1.49963 8 1.49963C5.51472 1.49963 3.5 3.51435 3.5 5.99963C3.5 8.48492 5.51472 10.4996 8 10.4996Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.5962 10.5958C11.3772 11.8148 9.72391 12.4996 8 12.4996C6.27609 12.4996 4.62279 11.8148 3.40381 10.5958C2.18482 9.37684 1.5 7.72354 1.5 5.99964C1.5 4.27573 2.18482 2.62243 3.40381 1.40344" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 14.4996H10" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 12.4996V14.4996" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
